// @ts-nocheck
import { isSiteInShellCookieName } from "@insite/client-framework/Common/ContentMode";
import { getCookie, setCookie } from "@insite/client-framework/Common/Cookies";
import isApiError from "@insite/client-framework/Common/isApiError";
import { StrictInputDispatch } from "@insite/client-framework/HandlerCreator";
import { setDisplayErrorPage } from "@insite/client-framework/ServerSideRendering";
import { ApiError } from "@insite/client-framework/Services/ApiService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { chain, DisplayError } from "@insite/client-framework/Store/Context/Handlers/HandleError";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";
/* Store Custom Code - Start */
const refreshPageIfNeeded = (state: ApplicationState, dispatch: StrictInputDispatch) => {
    if (getCookie(isSiteInShellCookieName) === "true") {
        // If we are in the Shell, trigger a modal open with an Unauthorized error
        dispatch({
            type: "Context/SetErrorModalIsOpenAndUnauthorized",
            isErrorModalOpen: true,
            isUnauthorizedError: true,
        });
        return;
    }
    const { isAuthenticated, rememberMe } = state.context.session;
    if (isAuthenticated || rememberMe) {
        const preventRefreshLoopCookieName = "lastPageRefresh";
        const datetime = +(getCookie(preventRefreshLoopCookieName) || "0");
        if (Date.now() - datetime > 30 * 1e3) {
            setCookie(preventRefreshLoopCookieName, Date.now().toString());
            window.location.reload();
        }
    }
};
/* Store Custom Code - End */
replaceInChain(chain, DisplayError, props => {
    if (IS_SERVER_SIDE) {
        setDisplayErrorPage(props.parameter.error);
        return;
    }
    /* Store Custom Code - Start */
    /* Some apis are returning 404 when user is logged out. We need to handle that the same way as 401/403 to stop users from getting a broken ui */
    if (
        props.parameter.error instanceof ApiError && // Store Custom - we're checking the instance of the error instead of the helper because some errors lack errorJson but are still ApiErrors
        (props.parameter.error.status === 401 || props.parameter.error.status === 403)
    ) {
        // auth session must have timed out - do a full refresh to update the header etc
        refreshPageIfNeeded(props.getState(), props.dispatch);
        return;
    }
    const is404LoggedOutApiError =
        !getCookie("CurrentBillToId") &&
        props.parameter.error instanceof ApiError &&
        props.parameter.error.status === 404;

    if (is404LoggedOutApiError) {
        refreshPageIfNeeded(props.getState(), props.dispatch);
        return;
    }
    /* Store Custom Code - End */
    if (
        `${props.parameter.error}` === "TypeError: NetworkError when attempting to fetch resource." &&
        /firefox|fxios/i.test(navigator.userAgent)
    ) {
        // Firefox sometimes cancels active fetch request before reloading page and it cause unnecessary error modal
        return;
    }

    props.dispatch({
        type: "Context/SetErrorModalIsOpen",
        isErrorModalOpen: true,
        apiError: isApiError(props.parameter.error) ? props.parameter.error : undefined,
    });
});
